<template>
  <div>
    <quill-editor ref="editor" :content="model" @change="val=> $emit('change', val.html)" @click.native="onClick" @input="onInput" :options="editorOption"></quill-editor>
    <div v-if="loading" class="has-bg-dark has-text-white"><i v-if="loading" class="fas fa-spinner fa-spin is-margin-xsmall"></i><span>Image en cours de chargement</span></div>
    <div :id="'toolbar' + now" class="is-paddingless">
      <!-- <span class="no-before">
        <select class="has-text-grey ql-size is-border-right"></select>
      </span> -->
      <span class="" v-if='!light'>
        <button class="is-border-right ql-header tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" value="1" data-tooltip='Premier titre'></button>
        <button class="is-border-right ql-header tooltip is-dark" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" value="2" data-tooltip='Second titre'></button>
      </span>
      <span class="">
        <button class="is-border-right ql-bold tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" data-tooltip='gras'></button>
        <button class="is-border-right ql-italic tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" data-tooltip='italic'></button>
        <button class="is-border-right ql-underline tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" data-tooltip='souligné'></button>
      </span>
      <span class="" v-if='!light'>
        <button class="is-border-right tooltip ql-script" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" value="super" data-tooltip='éxposant'></button>
      </span>
      <span class="" v-if='!lightProgram'>
        <button v-if='!light' class="is-border-right ql-list tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" value="ordered" data-tooltip='liste numérotée'></button>
        <button class="is-border-right ql-list tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" value="bullet" data-tooltip='liste à puce'></button>
        <button v-if='!light' class="is-border-right ql-indent tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" value="-1" data-tooltip='moins indenté'></button>
        <button v-if='!light' class="is-border-right ql-indent tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" value="+1" data-tooltip='plus indenté'></button>
      </span>
      <span class="" v-if='!light'>
        <select class="has-text-grey is-border-right ql-align tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" id='alignement' data-tooltip='alignement'></select>
      </span>
      <span class="" v-if='!light'>
        <button class="is-border-right ql-link tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" data-tooltip='lien'></button>
        <button class="has-text-grey is-border-right custom-img tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" type="button" @click="imageUpload()" data-tooltip='image'><i class="far fa-image"></i></button>
        <button class="is-border-right ql-video tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" data-tooltip='vidéo'></button>
      </span>
      <span class="">
        <button class="is-border-right ql-clean tooltip is-dark" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" data-tooltip='nettoyer'></button>
      </span>
      <span class="" v-if='!lightProgram'>
        <button id="emoji-button" class="is-border-right ql-emoji tooltip" :class="tooltipTop ? 'is-tooltip-top' : 'is-tooltip-bottom'" @click="emojiClick()" data-tooltip='emoji'></button>
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { difference } from 'lodash'
import 'quill-emoji/dist/quill-emoji'
import 'quill/dist/quill.snow.css'
import 'quill-emoji/dist/quill-emoji.css'

export default {
  name: 'WysiwygEditor',
  data () {
    return {
      now: new Date(),
      loading: false,
      imgStartList: null,
      imgStartListId: [],
      imgEndList: null,
      imgEndListId: []
    }
  },
  props: {
    tooltipTop: Boolean,
    lightProgram: Boolean,
    light: Boolean,
    submited: Boolean,
    model: String,
    isBubble: Boolean,
    hasImageUploader: Boolean,
    placeholder: String,
    hasLink: Boolean,
    fromQuickview: Boolean
  },
  watch: {
    submited () {
      this.updateSubmit()
    }
  },
  computed: {
    editorOption () {
      let options = {
        theme: this.isBubble ? 'bubble' : 'snow',
        placeholder: this.placeholder,
        modules: {
          toolbar: '#toolbar' + this.now,
          'emoji-toolbar': true,
          'emoji-shortname': true
          // {
          //   container: [
          //     ['bold', 'italic', 'underline'],
          //     [{ 'list': 'bullet' }],
          //     [{ 'size': ['small', false, 'large'] }],
          //     ['link'],
          //     ['image'],
          //     ['clean']
          //   ],
          //   handlers: {
          //     image: this.imageUpload()
          //   }
          // }
        }
      }
      return options
    },
    quill () {
      if (this.$refs.editor && this.$refs.editor.quill) {
        console.log(this.$refs)
        return this.$refs.editor.quill
      }
    }
  },
  methods: {
    emojiClick (val) {
      this.$nextTick(() => {
        let emojiOpen = document.querySelector('#tab-toolbar ul')
        if (emojiOpen) {
          emojiOpen.insertAdjacentHTML('beforeend', '<li class="emoji-tab filter-flags"><div id="close-emoji" class="fas fa-times i-flags"></div></li>')
          let emojiClose = document.querySelector('#close-emoji')
          emojiClose.addEventListener('click', () => {
            document.querySelector('#emoji-button').click()
          })
        }
      })
    },
    updateSubmit () {
      if (this.submited) {
        this.imgEndList = document.querySelectorAll('.ql-editor img')
        this.imgEndList.forEach((value, index) => {
          let url = value.src
          url = url.substring(url.lastIndexOf('/') + 1)
          let id = url.split('.').slice(0, -1).join('.')
          this.imgEndListId.push(id)
        })
        let differenceId = difference(this.imgStartListId, this.imgEndListId)
        differenceId.forEach((value, index) => {
          this.$fus.delete(value).then(res => {
          })
          .catch(() => {
          })
        })
      }
    },
    onClick (v) {
      if (v.target.localName === 'img') {
        if (v.target.style.width === '') {
          v.target.style.width = '25%'
        } else if (v.target.style.width === '25%') {
          v.target.style.width = '50%'
        } else if (v.target.style.width === '50%') {
          v.target.style.width = '75%'
        } else if (v.target.style.width === '75%') {
          v.target.style.width = '100%'
        } else if (v.target.style.width === '100%') {
          v.target.style.width = ''
        }
      }
    },
    onInput (v) {
      this.removeColor(v)
    },
    removeColor (v) {
      let elem = document.querySelectorAll('.ql-editor *')
      elem.forEach(element => {
        element.style.color = ''
        element.style.backgroundColor = ''
      })
    },
    imageUpload () {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', 'image/png, image/gif, image/jpeg')
      input.setAttribute('multiple', true)
      input.click()
      input.oninput = async () => {
        const files = Array.from(input.files)
        let filesToUpload = new FormData()
        this.loading = true
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          filesToUpload.append('file[]', file, file.name)
        }
        try {
          let res = await this.$fus.post({data: filesToUpload})
          let hostedFiles = res.data.slice()
          hostedFiles = hostedFiles.map(x => {
            return {
              fus_id: x.id,
              cloudinary_id: x.cloudinary_id,
              cloudinary_version: x.cloudinary_version,
              path: x.path,
              filename: x.filename
            }
          })
          this.loading = false
          hostedFiles.forEach(image => {
            const index = (this.quill.getSelection() || {}).index || this.quill.getLength()
            this.quill.insertEmbed(index, 'image', image.path, 'user')
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      }
    }
  },
  created () {
    this.now = moment(this.now).format('hmmssSSS')
    this.$nextTick(() => {
      this.imgStartList = document.querySelectorAll('.ql-editor img')
      this.imgStartList.forEach((value, index) => {
        let url = value.src
        url = url.substring(url.lastIndexOf('/') + 1)
        let id = url.split('.').slice(0, -1).join('.')
        this.imgStartListId.push(id)
      })
    })
  }
}
</script>

<style>
.ql-editor {
  min-height: 150px
}

.ql-tooltip.ql-editing {
  left: 0px !important;
  top: 0px !important;
}

.ql-toolbar.ql-snow {
  background-color: white;
  border: 1px solid rgba(204, 204, 204, .7);
}

.ql-toolbar.ql-snow > * {
  opacity: 0.95; /* 0.7 */ /* Attention baisser cette valeur modifi aussi le BG des tooltips... */
}

.ql-container.ql-snow {
  border-top: 1px solid rgba(204, 204, 204, .7);
  border-right: 1px solid rgba(204, 204, 204, .7);
  border-left: 1px solid rgba(204, 204, 204, .7);
  border-bottom: none;
  background-color: white;
}
.is-borderless > .quill-editor .ql-container.ql-snow {
  border-color: transparent;
}


.ql-toolbar button:hover {
  background-color: #f7f7f7 !important;
}

.ql-toolbar button .ql-fill {
  fill: #bebebe !important
}

.ql-toolbar button .ql-stroke {
  stroke: #bebebe !important
}

.ql-toolbar .ql-fill {
  fill: #bebebe !important
}

.ql-toolbar .ql-stroke {
  stroke: #bebebe !important
}

.ql-toolbar .ql-picker-label:hover {
  color: #bebebe !important
}

.ql-toolbar .ql-picker:hover {
  background-color: #f7f7f7 !important;
}

.ql-toolbar .ql-picker-item:hover{
  color: #bebebe !important;
  background-color: #f7f7f7 !important;
}

.ql-toolbar .ql-picker-item{
  padding-right: 10px;
  padding-left: 10px;
}
.ql-toolbar .ql-picker {
  height: 34px !important;
  width: 38px !important;
}

.ql-toolbar .ql-picker-label::before {
  line-height: 30px;
}

.ql-toolbar .ql-icon-picker .ql-picker-label {
  padding: 8px 10px !important;
}

.ql-toolbar .ql-picker.ql-size {
  width: 98px !important;
}

.ql-toolbar button {
  height: 34px !important;
  padding: 8px 10px !important;
  width: 38px !important;
}

.ql-toolbar .ql-picker.ql-expanded .ql-picker-options{
  padding: 0px;
}

.ql-picker:hover::after, .ql-toolbar .ql-picker.ql-expanded:hover::after, .ql-toolbar .ql-picker.ql-expanded:hover::before {
  display: none;
}

/* .ql-toolbar .no-before .ql-picker:hover::before, .ql-toolbar .no-before .ql-picker:hover::after, .ql-toolbar .ql-picker.ql-expanded:hover::after, .ql-toolbar .ql-picker.ql-expanded:hover::before {
  display: none;
} */

.ql-toolbar .ql-picker:hover::after {
  top: 8px !important;
}

.ql-toolbar .ql-picker:hover::before {
  margin-left: 0.5rem;
}

.ql-editor iframe {
  height: 250px;
  width: 500px;
}

.ql-toolbar button:focus, .ql-toolbar .ql-picker-label:focus {
  outline: none !important;
}

.custom-img {
  font-size: 1.1rem !important;
}

.ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 100%;
  padding: 2px 9px;
}

#emoji-palette #tab-panel {
  max-height: 100%;
  justify-content: start;
}

#close-emoji {
  height: 25px;
  margin: auto;
  width: 25px;
  color: dimgrey;
  font-size: 1.2em;
  background: none;
}

#close-emoji .fa-times:before {
  content: "\f00d";
  color: dimgrey;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

#tab-toolbar ul li {
  min-height: 26px !important;
  width: 26px !important;
}

span#alignement:focus::before, span#alignement:hover::before {
  top: 100%;
  bottom: auto;
  left: 50%;
  right: auto;
  border-color: transparent transparent rgba(74, 74, 74, 0.9) transparent;
}
span#alignement:focus::before, span#alignement:hover::before {
  opacity: 1;
  margin-left: -.5rem;
  margin-top: -.5rem;
}
span#alignement:hover:before {
  content: "";
  border-style: solid;
  border-width: .5rem;
}

span#alignement:hover::before, span#alignement:hover::after {
  z-index: 99999;
  position: absolute;
  display: inline-block;
  pointer-events: none;
}
span#alignement:focus::after, span#alignement:hover::after {
    -webkit-transform: translate(-50%, 0.5rem);
    transform: translate(-50%, 0.5rem);
}
span#alignement::after {
  margin-top: 26px;
  bottom: auto;
  left: 50%;
  right: auto;
}
span#alignement:focus::after, span#alignement:hover::after {
  opacity: 1;
}
span#alignement:hover::after {
  content: attr(data-tooltip);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 0.725rem;
  padding: .4rem .8rem;
  background: rgba(74, 74, 74, 0.9);
  border-radius: 4px;
  color: white;
  max-width: 24rem;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/WysiwygEditor.vue